// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"a6bef9ebd6ac43fca57e","655":"82fe678a6397eb30d13a"}[chunkId] + ".js";
};